import { Divider, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbLabels, label } from "./BreadcrumbLabels";
import { useTranslation } from "react-i18next";

const classes = {
  subMenu: {
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    padding: 0,
    background: "rgba(228, 230, 238, 1)",
    height: "60px",
    margin: "0 -30px",
    "& li": {
      position: "relative",
    },
    "@media (max-width: 1024px)": {
      margin: "0 -15px",
      "& *": {
        fontSize: "12px !important",
      },
    },
    "@media print": {
      display: "none",
    },
  },
  divider: {
    display: "inline-block",
    verticalAlign: "middle",
    height: "25px",
    margin: "auto 30px",
    width: "2px",
    backgroundColor: "rgba(188, 190, 201, 1)",
  },
  tab: {
    position: "relative",
    margin: "0 50px",
  },
  selectedTab: {
    display: "inline-block",
    boxShadow: "0 3px 0 rgb(111 117 138)",
    fontWeight: "bold",
    height: "60px",
    padding: "0 25px",
    lineHeight: "60px",
  },
  inActiveTab: {
    display: "inline-block",
    color: "rgba(111, 117, 138, 1)",
    fontSize: "0.9rem",
    padding: "0 25px",
    cursor: "pointer",
    "&:hover": {
      fontWeight: "bold",
    },
  },
};

const labelsBackground = ["rgba(209, 212, 225, 1)", "rgba(219, 220, 230, 1)"];

interface IProps {
  labels?: string[];
  clickHandler?(value: number): void;
}
export default function Breadcrumb({ labels, clickHandler }: IProps) {
  const navigate = useNavigate();
  let { pathname: url } = useLocation();
  const { t, i18n } = useTranslation();
  let newUrl = url.split("/");
  newUrl.shift();

  let label1 = BreadcrumbLabels[newUrl[0]]
    ? BreadcrumbLabels[newUrl[0]]["label"]
    : null;
  let label2 = BreadcrumbLabels[newUrl[1]]
    ? BreadcrumbLabels[newUrl[1]]["label"]
    : null;
  const customStyles = {
    breadcrumb: {
      display: "block",
      position: "relative",
      height: "60px",
      width: "fit-content",
      whiteSpace: "nowrap",
      minWidth: "200px",
      padding: i18n.dir() === "rtl" ? "0 50px 0 20px" : "0 20px 0 50px",
      lineHeight: "60px",
      color: "rgba(111, 117, 138, 1)",
      fontWeight: "bold",
      "&:after": {
        content: '""',
        position: "absolute",
        top: 6,
        ...(i18n.dir() === "rtl" ? { left: "-22px" } : { right: "-22px" }),
        bottom: 0,
        background: "inherit",
        width: 48,
        height: 48,
        transform: i18n.dir() === "rtl" ? "rotate(45deg)" : "rotate(225deg)",
        borderRadius: "10px",
        zIndex: 2,
        clipPath: "polygon(0% 0%, 100% 100%, 0% 100%)",
      },
    },

    link: {
      cursor: "pointer",
      textDecoration: "underline",
    },
    inActive: {
      pointerEvents: "none",
    },
  };

  return labels?.length ? (
    <Typography component="ul" sx={classes.subMenu}>
      {labels.map((label, index) => (
        <li key={"breadcrumb" + index}>
          <Typography
            sx={{
              ...customStyles.breadcrumb,
              ...(index !== labels.length - 1
                ? customStyles.link
                : customStyles.inActive),
              background: labelsBackground[index],
            }}
            onClick={() => clickHandler?.(index)}
          >
            {t(label)}
          </Typography>
        </li>
      ))}
    </Typography>
  ) : label1 ? (
    <Typography component="ul" sx={classes.subMenu}>
      <li>
        <Typography
          sx={{
            ...customStyles.breadcrumb,
            background: "rgb(209 212 225)",
          }}
        >
          {t(label1 as string)}
        </Typography>
      </li>
      {label1 &&
        Array.isArray(BreadcrumbLabels[newUrl[0]]["tab"]) &&
        (BreadcrumbLabels[newUrl[0]]["tab"] as label[]).map((item, index) => (
          <li key={index}>
            <Typography
              component="span"
              onClick={() => {
                navigate(item.path as string);
              }}
              sx={{
                ...(index === 0 ? classes.tab : {}),
                ...(item.label === label2
                  ? classes.selectedTab
                  : classes.inActiveTab),
              }}
            >
              {t(item.label as string)}
            </Typography>
            {BreadcrumbLabels[newUrl[0]]["tab"].length - 1 !== index && (
              <Divider
                sx={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  height: "25px",
                  margin: "auto 20px",
                  width: "2px",
                  backgroundColor: "rgba(188, 190, 201, 1)",
                }}
                orientation="vertical"
              />
            )}
          </li>
        ))}
    </Typography>
  ) : null;
}
